import DrawerButton from "components/form/DrawerButton";
import Title from "components/form/Title";
import useCancellationPolicySubmit from "hooks/useCancellationPolicySubmit";
import DynamicCancellationPolicy from "components/form/DynamicCancellationPolicy";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const CancellationPolicyDrawer = ({
  id,
  data,
  days,
  percentage,
  tab,
  type,
}) => {

  const {
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    onSubmit,
    trigger,
    errors,
    loading,
  } = useCancellationPolicySubmit(tab);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title title={"Edit CancellationPolicy"} />
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <DynamicCancellationPolicy
              dataInput={dataInput}
              tab={tab}
              type={type}
              setDataInput={setDataInput}
              days={days}
              percentage={percentage}
              policy={data}
              register={register}
              trigger={trigger}
              errors={errors}
              handleChange={handleChangeInput}
              cancellationpolicyndex={dataInput.length}
            />
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default CancellationPolicyDrawer;
